import { getEndpoints } from "../../Lib/Config/EndPoints/EndPoints";
import { apiRequest } from "../../Lib/Utils/ApiRequest";
import { IApiResponse, IBookedJourneyDetail, IBookingComment, IBookingCommentRequestPayload } from "../../Orchestrator/Types/Index";

export const FMLM_BOOKING_JOURNEY_COMMENT_TYPE = "COMMENT_TYPE.BOOKING_COMMENT"
export const FMLM_BOOKING_JOURNEY_COMMENT_LEVEL = "COMMENT_LEVEL.BOOKING"

export async function createBookingCommentAPI(bookingId: string, comment: IBookedJourneyDetail): Promise<IApiResponse<IBookingComment>> {
    const ENDPOINTS = await getEndpoints();
    const endpoint = `${ENDPOINTS.createBookingComment(bookingId)}`;

    const payload : IBookingCommentRequestPayload = {
        comment: JSON.stringify(comment),
        type: FMLM_BOOKING_JOURNEY_COMMENT_TYPE,
        level: FMLM_BOOKING_JOURNEY_COMMENT_LEVEL
    }

    return await apiRequest<IBookingComment>(endpoint, 'POST', {
        body: JSON.stringify(payload)
    });
}
